
import { useState } from "react";
import { SEO } from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";

import { HeroSection } from "@/components/influencer/sections/HeroSection";
import { StatsSection } from "@/components/influencer/sections/StatsSection";
import { CategoriesSection } from "@/components/influencer/sections/CategoriesSection";
import { CTASection } from "@/components/influencer/sections/CTASection";

const Influencers = () => {
  const { language } = useLanguage();
  const [stats] = useState({
    influencerReach: "N/A",
    averageEngagement: "N/A",
    successfulCampaigns: "N/A",
  });

  return (
    <div className="relative min-h-screen">
      <SEO
        title="Book Saudi Influencers — Fusion Media"
        description="Discover and book vetted Saudi influencers across every category. Run measurable influencer campaigns through the Fusion Media platform."
      />
      <div className={`relative max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 ${language === 'ar' ? 'text-right' : 'text-left'}`}>

        <div data-tour="inf-hero"><HeroSection /></div>
        <div className="pb-12 md:pb-16"><StatsSection stats={stats} /></div>
        <div data-tour="inf-categories" className="pb-16 md:pb-24"><CategoriesSection /></div>
        <div data-tour="inf-cta" className="pb-16 md:pb-24"><CTASection /></div>
      </div>
    </div>
  );
};

export default Influencers;
